import {lazy} from "react"

import {NATURE_CODE_STARTS_BY} from "src/constants/document"
import CommonUtils from "src/utils/Common"

import {ICON_BY_CYCLE} from "./nature-cycle-icons"
import {NATURE_CYCLE_ROUTE} from "./nature-cycle-route-map"

const Document = lazy(() => import("../views/Document"))

const STANDARD_USER = "STANDARD_USER"
const buildUrl = (type) => `/nd/${type}/:selectedTab?`

const getNatureCodeStartsBy = (natureCode) => NATURE_CODE_STARTS_BY[natureCode]

const hasDocTypeStartingBy = (natureCode) => () => {
    const natureCodeStartsBy = getNatureCodeStartsBy(natureCode)
    return CommonUtils.GetAllDocTypes().some((docType) => docType.code?.toUpperCase().startsWith(natureCodeStartsBy))
}

export const buildNatureRoutes = Object.entries(NATURE_CYCLE_ROUTE).map(([cycle, cfg]) => ({
    name: cfg.name,
    url: buildUrl(cfg.slug),
    icon: ICON_BY_CYCLE[cycle],
    roles: [STANDARD_USER],
    natureMappingCode: getNatureCodeStartsBy(cfg.codePrefix),
    component: <Document entity={cycle} url={cfg.name} />,
    conditioned: hasDocTypeStartingBy(cfg.codePrefix),
    ...(cfg.hasKeyWords ? {keyWords: [cfg.name]} : {})
}))
